import { useQuery, UseQueryOptions } from 'react-query';

import client from 'client';
import { ScheduledMeeting } from '../types';
import { ScheduledMeetingResponse } from './useScheduledMeetings';
import { parseScheduleMeeting } from './parseScheduleMeeting';

const fetchMeeting = async (eventId: number, meetingId: string) => {
    const response = await client().get<ScheduledMeetingResponse>(
        `/api/v2/meetings/events/${eventId}/scheduledMeetings/${meetingId}`
    );
    return response.data;
};

const useScheduledMeeting = (
    eventId: number,
    meetingId: string,
    options?: UseQueryOptions<ScheduledMeetingResponse, Error, ScheduledMeeting>
) => {
    return useQuery<ScheduledMeetingResponse, Error, ScheduledMeeting>(
        ['meetings', meetingId],
        () => fetchMeeting(eventId, meetingId),
        {
            ...options,
            select: parseScheduleMeeting,
            refetchOnWindowFocus: false,
            staleTime: 0,
            useErrorBoundary: true,
        }
    );
};

export default useScheduledMeeting;
